import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
        </p>
        <a
          className="App-link"
          href="https://readwright.substack.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          Please visit our Read Wright on Substack!
        </a>
      </header>
    </div>
  );
}

export default App;
